export default __webpack_public_path__ + "static/media/4.cd90c08f.png";